import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Correct import

const posts = [
  { id: 'blog-1', img: 'blog-1.jpg', title: 'The Role Of Modern Car Wreckers', date: 'March 29, 2025' },
  { id: 'blog-2', img: 'blog-2.jpg', title: 'Recycling Auto Parts', date: 'March 30, 2025' },
  { id: 'blog-3', img: 'blog-3.jpg', title: 'Eco-Friendly Car Disposal', date: 'March 31, 2025' },
];

const BlogSection = () => (
  <section className="Blog-sec pt-6 pb-6">
    <div className="container">
      <div className="about-text mb-5">
        <h6 className="wow animate__animated animate__fadeInDown" data-wow-delay="0.5s">
          Blogs
        </h6>
        <h2 className="wow animate__animated animate__fadeInUp" data-wow-delay="0.6s">
          News and Blogs
        </h2>
      </div>
      <div className="row">
        {posts.map((post, idx) => (
          <div className="col-lg-4" key={idx}>
            <div className="blog-box">
              <div className="blog-img">
                <img src={`/project/images/${post.img}`} alt={post.title} />
              </div>
              <div className="blog-text">
                <div className="blog-date">
                  <i className="fa-solid fa-calendar-days"></i>
                  <span>{post.date}</span>
                </div>
                <h2>{post.title}</h2>
                {/* ✅ Fixed link (remove `/project` from path) */}
                <Link to={`/blog/${post.id}`}>Read More</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BlogSection;
